import {
  addMemberViolation,
  deleteViolation,
  getallMemberViolations,
  getViolationsByMemberId,
  resetViolation,
  updateMemberViolation,
} from "./ViolationActions";
import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  violationsList: any[];
  violationsListLoading: boolean;
  violationsListError: any | null;

  resetMemberViolationLoading: boolean;
  resetMemberViolationError: any | null;

  deleteMemberViolationLoading: boolean;
  deleteMemberViolationError: any | null;

  addMemberViolationLoading: boolean;
  addMemberViolationError: any | null;

  updateMemberViolationLoading: boolean;
  updateMemberViolationError: any | null;

  violationsByMemberIdList: any[] | null;
  violationsByMemberIdLoading: boolean;
  violationsByMemberIdError: any | null;
}

const initialState: InitialState = {
  violationsList: [],
  violationsListLoading: false,
  violationsListError: null,

  resetMemberViolationLoading: false,
  resetMemberViolationError: null,

  deleteMemberViolationLoading: false,
  deleteMemberViolationError: null,

  addMemberViolationLoading: false,
  addMemberViolationError: null,

  updateMemberViolationLoading: false,
  updateMemberViolationError: null,

  violationsByMemberIdList: null,
  violationsByMemberIdLoading: false,
  violationsByMemberIdError: null,
};

export const violationSlice = createSlice({
  name: "violation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getallMemberViolations.pending, (state) => {
      state.violationsListLoading = true;
      state.violationsListError = null;
      state.violationsList = [];
    });
    builder.addCase(getallMemberViolations.fulfilled, (state, action) => {
      state.violationsList = action.payload;
      state.violationsListLoading = false;
      state.violationsListError = null;
    });
    builder.addCase(getallMemberViolations.rejected, (state, action) => {
      state.violationsListError = action.payload;
      state.violationsListLoading = false;
      state.violationsList = [];
    });
    builder.addCase(resetViolation.pending, (state) => {
      state.resetMemberViolationLoading = true;
      state.resetMemberViolationError = null;
    });
    builder.addCase(resetViolation.fulfilled, (state, action) => {
      state.resetMemberViolationLoading = false;
      state.resetMemberViolationError = null;
    });
    builder.addCase(resetViolation.rejected, (state, action) => {
      state.resetMemberViolationError = action.payload;
      state.resetMemberViolationLoading = false;
    });
    builder.addCase(deleteViolation.pending, (state) => {
      state.deleteMemberViolationLoading = true;
      state.deleteMemberViolationError = null;
    });
    builder.addCase(deleteViolation.fulfilled, (state, action) => {
      state.deleteMemberViolationLoading = false;
      state.deleteMemberViolationError = null;
    });
    builder.addCase(deleteViolation.rejected, (state, action) => {
      state.deleteMemberViolationError = action.payload;
      state.deleteMemberViolationLoading = false;
    });
    builder.addCase(getViolationsByMemberId.pending, (state) => {
      state.violationsByMemberIdLoading = true;
      state.violationsByMemberIdError = null;
      state.violationsByMemberIdList = [];
    });
    builder.addCase(getViolationsByMemberId.fulfilled, (state, action) => {
      state.violationsByMemberIdList = action.payload;
      state.violationsByMemberIdLoading = false;
      state.violationsByMemberIdError = null;
    });
    builder.addCase(getViolationsByMemberId.rejected, (state, action) => {
      state.violationsByMemberIdError = action.payload;
      state.violationsByMemberIdLoading = false;
      state.violationsByMemberIdList = null;
    });
    builder.addCase(addMemberViolation.pending, (state) => {
      state.addMemberViolationLoading = true;
      state.addMemberViolationError = null;
      state.violationsByMemberIdList = null;
    });
    builder.addCase(addMemberViolation.fulfilled, (state, action) => {
      state.addMemberViolationLoading = false;
      state.addMemberViolationError = null;
    });
    builder.addCase(addMemberViolation.rejected, (state, action) => {
      state.addMemberViolationError = action.payload;
      state.addMemberViolationLoading = false;
    });
    builder.addCase(updateMemberViolation.pending, (state) => {
      state.updateMemberViolationLoading = true;
      state.updateMemberViolationError = null;
    });
    builder.addCase(updateMemberViolation.fulfilled, (state) => {
      state.updateMemberViolationLoading = false;
      state.updateMemberViolationError = null;
    });
    builder.addCase(updateMemberViolation.rejected, (state, action) => {
      state.updateMemberViolationError = action.payload;
      state.updateMemberViolationLoading = false;
    });
  },
});

const violationReducer = violationSlice.reducer;

export default violationReducer;
